import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

interface Props {
    endTime?: number;
}

const Comp: React.FC<Props> = ({ endTime }) => {
    const { getSystemTime, useRouter } = useGlobal();
    const router = useRouter();
    const { locale = 'us' } = getLocal();
    const { t } = useLang('theProduct.EarlyBirdOffer');

    let systemTime = getSystemTime();
    const { _timer } = router.query;
    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }
    if (endTime && systemTime >= endTime) return null;

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1755249891069/1.png',
            title: t('item1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1755249890550/2.png',
            title: t('item2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1755249890907/3.png',
            title: t('item3'),
        },
    ];
    return (
        <div className={styles.comp} id="EarlyBirdOffer">
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <div className="container">
                {list.map((i, idx) => (
                    <div className="item" key={idx}>
                        <EcoImg pc={i.pc} />
                        <div className="title">{i.title}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Comp;
